import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'nsp-clock-display',
  templateUrl: './clock-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, DatePipe],
})
export class ClockDisplayComponent {
  readonly time = input.required<Date>();
  readonly format = input.required<string>();
  readonly label = input<string>();
}
